import createReactClass from "create-react-class";
import React from "react";
import { ControlLabel } from "react-bootstrap";

//stores
import { subdivisionStore } from "../stores/subdivision";
import { userStore } from "../stores/user";
import { restrictionRequestStore } from "../stores/restrictionRequest";
//Actions
var SubdivisionActionCreator = require("../actions/compare/compareSubdivisionActions");
import { ServerActions } from "../actions/serverActions";

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {
    selectableSubList: subdivisionStore.getSubList(),
    entireSubList: subdivisionStore.getEntireSubList(),
    selectedSub: subdivisionStore.getSelectedSub(),
    subData: subdivisionStore.getSubData(),
    isSubSelected: subdivisionStore.isSubSelected(),
    subsForTerritory: subdivisionStore.getSubList(),
    userType: userStore.getSelectedRole(),
    isDispatcher: userStore.isDispatcher(),
    isDirty: restrictionRequestStore.isDirty(),
  };
}

var SubdivisionView = createReactClass({
  componentDidMount: function () {
    subdivisionStore.subscribe(this._onChange);
    ServerActions.getSubdivisionList();
    userStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    subdivisionStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  onSubSelectChange: function (event) {
    var val = event.target.value;

    SubdivisionActionCreator.selectChanged(val);
  },

  //modify this to return the formBform view markup
  render: function () {
    var subdivisions = [];
    var disableSubSelector = false;
    var selectText = "Select...";
    if (this.state.selectableSubList) {
      subdivisions = this.state.selectableSubList.map(function (sub, i) {
        return (
          <option key={i + 1} value={sub.name}>
            {sub.name}
          </option>
        );
      });
      subdivisions.splice(
        0,
        0,
        <option disabled key={0} value="0">
          {selectText}
        </option>
      );
    }

    return (
      <div>
        <ControlLabel style={{ color: "gray" }}>Sub:</ControlLabel>{" "}
        <select
          id="subdivisionSelect"
          disabled={disableSubSelector}
          value={this.state.selectedSub}
          onChange={this.onSubSelectChange}
        >
          {subdivisions}
        </select>
      </div>
    );
  },
});

export default SubdivisionView;
